import React, { useState, useEffect } from "react";
import {
    LocalizationProvider,
    DesktopDateRangePicker,
    DateRange,
    SingleInputDateRangeField,
    RangePosition,
} from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Base } from "../../framework/base";
import { TextFieldProps } from "@mui/material";

interface IMuiDateRangePicker {
    value: [string, string];
    label: string;
    onChange: (val: [string, string]) => void;
    error?: boolean;
    helperText?: string;
    required?: boolean;
    size?: TextFieldProps["size"];
}

const getDateRangePickerValue = (range: [string, string]): [Dayjs, Dayjs] => [
    dayjs(range[0]),
    dayjs(range[1]),
];

export const MuiDateRangePicker = ({
    value,
    onChange,
    error,
    helperText,
    required,
    label,
    size,
}: IMuiDateRangePicker) => {
    const [dateRange, setDateRange] = useState<DateRange<Dayjs>>(
        getDateRangePickerValue(value)
    );
    const [rangePosition, setRangePosition] = useState<RangePosition>("start");

    useEffect(() => {
        setDateRange(getDateRangePickerValue(value));
    }, value);

    const handleAccept = (value: DateRange<Dayjs>) => {
        setDateRange(value);
        if (onChange) {
            onChange([
                value[0] ? Base.dayjsToJsonDate(value[0]) : null,
                value[1] ? Base.dayjsToJsonDate(value[1]) : null,
            ]);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fi">
            <DesktopDateRangePicker
                label={label}
                value={dateRange}
                onAccept={handleAccept}
                format="D.M.YYYY"
                slots={{ toolbar: null, field: SingleInputDateRangeField }}
                rangePosition={rangePosition}
                onOpen={() => setRangePosition("start")} // Set range position to start when opened
                onRangePositionChange={setRangePosition}
                slotProps={{
                    textField: {
                        size,
                        helperText,
                        error: !!error,
                        required,
                        sx: { width: "13.25rem" },
                    },
                }}
            />
        </LocalizationProvider>
    );
};
